//============================================================================
// Name        : ls_compare.ts
// Purpose     : Implement actions on Lightspeed compare page
// Created     : 2020-03-24
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import {InitPage} from "../index";
import { LsDownload } from "./ls_download";
import { LsSync } from "./ls_sync";
import { LsSyncCategories } from "./ls_sync_categories";

declare const integrationErrors: string;
declare const lsSyncInProgress: boolean;

export interface LsProgressChannelData {
    message: string;
    inProgress: boolean;
    progress: number;
    state: string;
    success: boolean;
}

class LsCompare {
    lsDownload: LsDownload;
    lsSync: LsSync;
    lsSyncCategories: LsSyncCategories;

    constructor() {
        this.lsDownload       = new LsDownload();
        this.lsSync           = new LsSync();
        this.lsSyncCategories = new LsSyncCategories();

        // If there are errors on the integration configuration, we'll display a dialog instead of the normal flow
        if (integrationErrors != "") {
            $(".action-ls-download").on("click",      () => { this.showIntegrationErrors(); });
            $(".action-ls-sync").on("click",          () => { this.showIntegrationErrors(); });
            $(".action-ls-category-sync").on("click", () => { this.showIntegrationErrors(); });
            return;
        }

        // console.log("lsSyncInProgress:", lsSyncInProgress);
        // Bind sync actions
        if (lsSyncInProgress == true) {
            this.lsDownload.connectLScable(this.lsDownload.dialogId, (data: LsProgressChannelData) => {
                $("#ls_sync_progress").text(data.message);
                $("#ls_dl_progress").text(data.message);
                $(".progress-bar").css("width", `${data.progress == null ? 100 : data.progress }%`);
                $("#dlProgressLabel").text(`${data.progress == null ? 100 : data.progress }%`);
                $("#ProgressLabel").text(`${data.progress == null ? 100 : data.progress }%`);
                if ((!data.inProgress) && (data.success) && (data.message == "Updated the store ls preview sync identifier")) {
                    window.location.reload();
                }
            });
        }
        $(".action-ls-download").on("click",      () => { this.lsDownload.show();       });
        $(".action-ls-sync").on("click",          () => { this.lsSync.show();           });
        $(".action-ls-category-sync").on("click", () => { this.lsSyncCategories.show(); });
    }

    showIntegrationErrors() {
        $("#integrationErrorsDialog .errors").html(integrationErrors);
        $("#integrationErrorsDialog").modal("show");
    }
}

export function LoadPage() {
    InitPage("compare_v2", () => {
        if ($("body").hasClass("sync_preview")) {
            return;
        }
        const lsCompare = new LsCompare();
    });
}
